// extracted by mini-css-extract-plugin
export default {"form":"form___dzxHj","textarea":"textarea___vNmOC","submitButton":"submitButton___zqZ0D","message":"message___aIx2N"};